import {Injectable} from '@angular/core';
import {CacheState} from '../modules/akita-mimic/models/store-states/cache-state.model';
import {StoreService} from '../modules/akita-mimic/services/store.service';

@Injectable({ providedIn: 'root' })
export class CacheStore extends StoreService<CacheState> {
    public constructor() {
        super('cache', {
            items: [],
            maxAgesInSeconds: undefined,
        });
    }
}
